<template>
  <div :class="[isOpen ? 'is-open' : '', $mq === 'sm' ? 'panel-side-sm' : 'panel-side']">
    <div class="panel">
      <ul>
        <li v-for="collection in collections" :key="collection.id" @click="selectCollection(collection)">
          <div :class="{'selected' : collectionActive === collection}">{{ collection.title }}</div>
          <div class="menu-icon">
            <vue-material-icon v-if="collectionActive === collection" name="remove_circle_outline" :size="24"/>
            <vue-material-icon v-else name="add_circle" :size="24"/>
          </div>
        </li>
      </ul>
      <div class="collection" v-if="collectionActive !== null">
        <!--<h3>{{ // collectionActive.title }}</h3>-->
        <p>{{ collectionActive.description }}</p>
        <img :src="collectionActive.image">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PanelCollections",
    props: {
      isOpen: {
        type: Boolean,
        default: true
      },
      collections: Array,
      collectionActive: Object
    },
    methods: {
      selectCollection(collection) {
        this.$emit('select-collection', collection)
      }
    },
    data() {
      return {}
    },
  }
</script>

<style lang="scss" scoped>

  @import "../styles/variables";

  .menu-icon {
    position: relative;
    float: right;
    max-width: 10% !important;

    span {
      font-weight: normal;
      color: $red;
    }
  }

  .panel {
    li {
      height: 55px !important;

      div {
        font-size: 18px;
        font-weight: bold;
        color: $gray;
        float: left;
        max-width: 90%;
      }
    }
  }

  .collection {
    width: 400px;

    h3 {
      color: $red;
      font-weight: bold;
      margin-bottom: 0px !important;
    }

    img {
      width: 100%;
    }

    p {
      margin-top: 10px !important;
      font-weight: 300;
      line-height: 1.3;
      color: $gray;
    }
  }

  @media (max-width: 490px) {
    .collection {
      width: 100%;
      padding-bottom: 190px;
    }
  }


</style>
